// DATI DEL SITO RED STONE - modifica qui i contenuti, poi esegui: yarn build
// Aggiungi un evento copiando un oggetto: { id, title, date: '2026-12-31', time: '21:00', tag: 'DJ Set', description: '...', image: '/assets/locandina.jpg', active: true }
export const events = [];
